var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CmsLink',{attrs:{"model":_vm.link}},[_c('img',{attrs:{"alt":_vm.model.caption,"src":_vm.imageSource}})])}
var staticRenderFns = []

export { render, staticRenderFns }